import React from 'react';
import ReactDOM from 'react-dom';

import App from 'modules/app';
import { AppProvider } from 'modules/context/app';
import { addOneTrustScript } from 'utils/scripts';
import { configuration } from 'configuration';

if (configuration.oneTrust.url && configuration.oneTrust.data) {
    addOneTrustScript(configuration.oneTrust.url, configuration.oneTrust.data);
}

ReactDOM.render(
    <React.StrictMode>
        <AppProvider>
            <App />
        </AppProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
